<section class="contact-us pt-5">
  <div class="container py-5">
    <h1 class="title mb-2">{{ "contact.title" | translate }}</h1>
    <p class="subtitle fs-5 mb-0 mt-3">
      {{ "contact.paragh1" | translate }}<br />
    </p>
    <p class="fw-semibold paragh2">{{ "contact.paragh2" | translate }}</p>

    <p class="paragh3">
      {{ "contact.paragh3" | translate }}
      <a class="email" href="mailto:contact@hilbertech.com"
        >contact&#64;hilbertech.com</a
      >
    </p>
  </div>
  <div class="contact">
    <app-contact-us-form></app-contact-us-form>
  </div>
</section>
